// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"120":"dd7a467fb48a5b143cc6","856":"4486c77ac0cb4147dc75","894":"302908b64400abc978eb"}[chunkId] + ".bundle.js";
};